import { createIcon } from '@chakra-ui/react';

export const Team = createIcon({
  displayName: 'Team',
  viewBox: '0 0 24 24',
  path: (
    <g id="Icon" transform="translate(-57 -708.999)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(57 708.999)"
        fill="none"
      />
      <g id="SJ-Icon-B_TeamPeople_DkGray_RGB" transform="translate(57 708.999)">
        <path
          id="Path_2181"
          data-name="Path 2181"
          d="M14.24,22.521a2.12,2.12,0,1,0-2.12-2.12A2.122,2.122,0,0,0,14.24,22.521Zm0-3.084a.964.964,0,1,1-.964.964A.965.965,0,0,1,14.24,19.437Z"
          transform="translate(-7.836 -11.623)"
          fill="currentColor"
        />
        <path
          id="Path_2182"
          data-name="Path 2182"
          d="M12.94,1A11.942,11.942,0,1,0,24.882,12.937,11.955,11.955,0,0,0,12.94,1Zm0,22.729A10.787,10.787,0,1,1,23.726,12.937,10.8,10.8,0,0,1,12.94,23.724Z"
          transform="translate(-0.998 -0.995)"
          fill="currentColor"
        />
        <path
          id="Path_2183"
          data-name="Path 2183"
          d="M27.955,21.2a2.535,2.535,0,1,0-2.535-2.535A2.538,2.538,0,0,0,27.955,21.2Zm0-3.914a1.379,1.379,0,1,1-1.379,1.379A1.381,1.381,0,0,1,27.955,17.282Z"
          transform="translate(-16.013 -10.298)"
          fill="currentColor"
        />
        <path
          id="Path_2184"
          data-name="Path 2184"
          d="M43,22.521a2.12,2.12,0,1,0-2.12-2.12A2.122,2.122,0,0,0,43,22.521Zm0-3.084a.964.964,0,1,1-.964.964A.965.965,0,0,1,43,19.437Z"
          transform="translate(-25.517 -11.623)"
          fill="currentColor"
        />
        <path
          id="Path_2185"
          data-name="Path 2185"
          d="M26.434,34.638l-.373-1.763a2.108,2.108,0,0,0-1.51-1.606,7.207,7.207,0,0,0-3.769,0,2.1,2.1,0,0,0-.82.449,2.431,2.431,0,0,0-.421-.167,9.016,9.016,0,0,0-4.827,0,2.425,2.425,0,0,0-.42.166,2.1,2.1,0,0,0-.82-.449,7.215,7.215,0,0,0-3.769,0A2.108,2.108,0,0,0,8.2,32.875l-.373,1.763a.578.578,0,0,0,.565.7h2.965a.578.578,0,1,0,0-1.156H9.1l.225-1.066a.956.956,0,0,1,.683-.731,6.04,6.04,0,0,1,3.16,0,.953.953,0,0,1,.221.1,2.531,2.531,0,0,0-.423.957l-.48,2.266a.578.578,0,0,0,.565.7H21.2a.578.578,0,0,0,.565-.7l-.479-2.266a2.532,2.532,0,0,0-.423-.956.929.929,0,0,1,.222-.1,6.042,6.042,0,0,1,3.16,0,.956.956,0,0,1,.683.731l.226,1.066H22.9a.578.578,0,1,0,0,1.156h2.965a.578.578,0,0,0,.565-.7Zm-12.668.607.332-1.569a1.322,1.322,0,0,1,.928-1.013,7.852,7.852,0,0,1,4.2,0,1.321,1.321,0,0,1,.927,1.013l.332,1.569H13.766Z"
          transform="translate(-5.186 -19.453)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
